/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-04-14 12:13:29
 * @FilePath: /bar-admin/src/permission.ts
 */
import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { getTestRoleApi, getAdminRoleApi, getCurUserDetailApi } from '@/api/login'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  start()
  loadStart()
  const permissionStore = usePermissionStoreWithOut()
  const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (permissionStore.getIsAddRouters) {
        next()
        return
      }

      const res = await getCurUserDetailApi()
      //   if (res) {
      //     userStore.setUserInfo(res.data)
      //     userStore.setRoleRouters(res.data.perms)

      // 开发者可根据实际情况进行修改
      // const roleRouters = userStore.getRoleRouters || []
      // const params = {
      //   roleName: 'admin'
      // }
      // const res =
      //   appStore.getDynamicRouter && appStore.getServerDynamicRouter
      //     ? await getAdminRoleApi(params)
      //     : await getTestRoleApi(params)

      if (res) {
        // const roleRouters = res.data.perms || []
        // 根据平台类型字段platform过滤 platform： 0:后端，1:前段，2：企微
        const roleRouters = res.data.perms.filter((item) => item.platform === 0)
        // 变更全局路由
        userStore.setRoleRouters(roleRouters)
        // 是否使用动态路由
        if (appStore.getDynamicRouter) {
          appStore.serverDynamicRouter
            ? await permissionStore.generateRoutes(
                'server',
                roleRouters as AppCustomRouteRecordRaw[]
              )
            : await permissionStore.generateRoutes('frontEnd', roleRouters as string[])
        } else {
          await permissionStore.generateRoutes('static')
        }

        permissionStore.getAddRouters.forEach((route) => {
          router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
        })
        console.log(to.query.redirect, to.path)

        const redirectPath = to.query.redirect || to.path
        const redirect = decodeURIComponent(redirectPath as string)

        const path = permissionStore.addRouters[0].path
        const lastPath = permissionStore.addRouters[0]?.children?.[0]?.path
          ? `/${permissionStore.addRouters[0].children[0].path}`
          : ''
        const nextData = to.query.redirect ? { path: redirect } : { ...to, replace: true }
        // const nextData =
        //   to.path === redirect
        //     ? { ...to, path: path + lastPath, replace: true }
        //     : { path: redirect }
        // const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
        permissionStore.setIsAddRouters(true)

        next(nextData)
      }
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
